/** @format */

export enum SectionPreviewBlockImagePosition {
    LEFT = 'left',
    RIGHT = 'right',
}

export enum SectionPreviewBlockVariant {
    SUSTAINABILITY = 'SUSTAINABILITY',
    FLAME = 'FLAME',
}

export const DEFAULT_TEST_ID = 'section-preview-block';
